// Interface definition
export interface ISafeObject {
  readonly cls: string;
  readonly id?: string;
}

// Utility functions to replace class methods
export const SafeObjectUtils = {
  // Create a new ISafeObject
  create({ cls, id }: { cls: string; id?: string }): ISafeObject {
    return { cls, id };
  },

  // Create an empty ISafeObject
  empty(): ISafeObject {
    return { cls: "", id: "" };
  },

  // Convert to map/record
  toMap(obj: ISafeObject): Record<string, any> {
    return {
      class: obj.cls,
      id: obj.id,
    };
  },

  // Convert to JSON string
  toJson(obj: ISafeObject): string {
    return JSON.stringify(SafeObjectUtils.toMap(obj));
  },

  // Create ISafeObject from map
  fromMap(map: Record<string, any>): ISafeObject {
    try {
      return {
        cls: String(map["class"]),
        id: String(map["id"]),
      };
    } catch (e) {
      console.error(String(e));
      console.error(e);
      SafeObjectUtils.empty();
    }
  },

  // Equality check
  equals(obj1: ISafeObject, obj2: ISafeObject): boolean {
    if (obj1 === obj2) return true;
    return obj1.cls === obj2.cls && obj1.id === obj2.id;
  },

  // Convert to string representation
  toString(obj: ISafeObject): string {
    return `class: ${obj.cls}, id: ${obj.id}`;
  },
};
